import { defineNuxtPlugin, useRuntimeConfig } from "#app";
import { EchoService } from "../services/EchoService.mjs";
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  return {
    provide: {
      echo: new EchoService(config.public.echoUrl, config.public.debug ?? false)
    }
  };
});
